(function () {
  function init(root) {
    const track = root.querySelector('[data-pv-ord-science-track]');
    if (!track || track.dataset.pvMarqueeInit) return;
    track.dataset.pvMarqueeInit = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let offset = 0;
    const speed = 0.35;
    let paused = false;

    root.addEventListener('mouseenter', () => {
      paused = true;
    });
    root.addEventListener('mouseleave', () => {
      paused = false;
    });
    root.addEventListener('focusin', () => {
      paused = true;
    });
    root.addEventListener('focusout', () => {
      paused = false;
    });

    const tick = () => {
      const half = track.scrollWidth / 2;
      if (half <= 0) return;
      if (!paused) {
        offset += speed;
        if (offset >= half) offset = 0;
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      }
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  document.querySelectorAll('[data-pv-ord-science]').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-pv-ord-science]');
    if (el) init(el);
  });
})();
